exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[_v-3a843fd0]{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3a843fd0&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Hello.vue
// module id = 350
// module chunks = 0